// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    getProductIdsForCompare,
    getProductsForCompare,
} from "@insite/client-framework/Store/Components/CompareProductsDrawer/CompareProductsDrawerSelectors";
import loadProductIdsToCompare from "@insite/client-framework/Store/Components/CompareProductsDrawer/Handlers/LoadProductIdsToCompare";
import loadProductsToCompare from "@insite/client-framework/Store/Components/CompareProductsDrawer/Handlers/LoadProductsToCompare";
import removeAllProductsFromCompare from "@insite/client-framework/Store/Components/CompareProductsDrawer/Handlers/RemoveAllProductsFromCompare";
import removeProductIdToCompare from "@insite/client-framework/Store/Components/CompareProductsDrawer/Handlers/RemoveProductFromCompare";
import setProductCompareReturnUrl from "@insite/client-framework/Store/Components/CompareProductsDrawer/Handlers/SetProductCompareReturnUrl";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import Carousel, { CarouselSlide, CarouselStyles } from "@insite/content-library/Components/Carousel";
// import ProductCarouselProductCondensed from "@insite/content-library/Components/ProductCarouselProductCondensed"; // Starter Custom Code
import Button, { ButtonIcon, ButtonIconPresentationProps, ButtonPresentationProps } from "@insite/mobius/Button";
// import Drawer, { DrawerPresentationProps, DrawerProps } from "@insite/mobius/Drawer"; // Starter Custom Code
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import X from "@insite/mobius/Icons/X";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
// import React, { useEffect, useState } from "react"; // Starter Custom Code
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import Accordion, { AccordionPresentationProps } from "@insite/mobius/Accordion";
import AccordionSection, { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import Link, { LinkPresentationProps } from "@insite/mobius/Link/Link";
import constants from "@store/constants";
import CompareFill from "@store/Library/Components/Toolkit/Icons/Compare/CompareFill";
import TrashFill from "@store/Library/Components/Toolkit/Icons/Trash/TrashFill";
import Drawer, { DrawerPresentationProps } from "@store/MobiusOverrides/Drawer/Drawer";
import ProductCarouselProductCondensed from "@store/Overrides/Components/ProductCarouselProductCondensed";
import { inlineSeparatorStyles } from "@store/Themes/common/mixins/typography";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import { productCardProps } from "@store/Themes/common/props/productCard";
import { productCompareEmptySlides, productCompareProps } from "@store/Themes/common/props/productCompare";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { useSiteContext } from "@toolkit/Framework/Components/SiteContext";
import { useWindowContext } from "@toolkit/Framework/Components/WindowContext";
import { focusUpdateStyles, siteWidthStyles } from "@toolkit/Themes/common/mixins";
import React, { Ref, useEffect, useState } from "react";

const accordionSectionStyles = () => {
    return css`
        padding-bottom: 0;
        padding-left: 0;
        padding-right: 0;
        background: transparent;
        border-color: transparent;
        border-bottom-color: transparent;
    `;
};

const slideGap = pxToRem(10);
const slideInView = [1.25, 2.25, 3.25, 4];
/* Starter Custom Code - End */

const PRODUCT_COMPARE_CAROUSEL_ID = constants.productCompare.carouselId; // Starter Custom Code

interface OwnProps {
    extendedStyles?: ProductCompareFlyOutStyles;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

const mapStateToProps = (state: ApplicationState) => ({
    productIds: getProductIdsForCompare(state),
    products: getProductsForCompare(state),
    productComparePageLink: getPageLinkByPageType(state, "ProductComparePage"),
    currentLocation: getLocation(state),
});

const mapDispatchToProps = {
    loadProductIdsToCompare,
    loadProductsToCompare,
    removeProductIdToCompare,
    removeAllProductsFromCompare,
    setProductCompareReturnUrl,
};

export interface ProductCompareFlyOutStyles {
    carousel?: CarouselStyles;
    carouselDrawer?: DrawerPresentationProps;
    carouselDrawerContainer?: InjectableCss;
    removeProductFromCompareButton?: ButtonPresentationProps;
    removeProductFromCompareButtonIcon?: ButtonIconPresentationProps;
    headerGridContainer?: GridContainerProps;
    headerTitleGridItem?: GridItemProps;
    headerTitleText?: TypographyPresentationProps;
    headerActionsGridItem?: GridItemProps;
    headerRemoveAllButton?: ButtonPresentationProps;
    headerCompareButton?: ButtonPresentationProps;
    // Starter Custom Code
    accordion?: AccordionPresentationProps;
    accordionSection?: AccordionSectionPresentationProps;
    actionsWrapper?: InjectableCss;
    headerRemoveAllLink?: LinkPresentationProps;
    headerCompareLink?: LinkPresentationProps;
    carouselSlide?: InjectableCss;
    carouselSlideInner?: InjectableCss;
    emptySlideInner?: InjectableCss;
    carouselContainer?: InjectableCss;
    carouselSlidesContainer?: InjectableCss;
    condensedActions?: InjectableCss;
}

export const productCompareFlyOutStyles: ProductCompareFlyOutStyles = {
    carouselDrawer: {
        position: "bottom",
        cssOverrides: {
            scrim: css`
                ${x => x.theme.drawer.defaultProps?.cssOverrides?.scrim}
                box-shadow: ${x => x.theme.shadows.e60Up};
                height: auto;
                background: ${getColor("common.accent")};
                color: ${getColor("text")};
            `,
            drawerBody: css`
                ${x => x.theme.drawer.defaultProps?.cssOverrides?.drawerBody}
                position: relative;
                height: auto;
                background: transparent;
            `,
            drawerTitle: css`
                ${x => x.theme.drawer.defaultProps?.cssOverrides?.drawerTitle}
                display: none;
            `,
            drawerContent: css`
                ${x => x.theme.drawer.defaultProps?.cssOverrides?.drawerContent}
                ${siteWidthStyles()}
                width: 100%;
                overflow: hidden;
                ${x => breakpointValues(x.theme.design.accordion.padding.horizontal, "padding-bottom")}
                margin: 0 auto;
                background: initial;
                color: inherit;
            `,
        },
        closeButtonProps: {
            css: css`
                display: none;
            `,
        },
        enableClickThrough: true,
    },
    removeProductFromCompareButton: productCompareProps.removeProductFromCompareButton,
    removeProductFromCompareButtonIcon: productCompareProps.removeProductFromCompareButtonIcon,
    headerTitleText: {
        forwardAs: "h2",
        variant: "h5",
        css: css`
            margin-bottom: 0;
        `,
    },
    actionsWrapper: {
        css: css`
            display: flex;
            margin: ${pxToRem(10)} 0;

            ${breakpoint("sm")} {
                justify-content: flex-end;
            }
        `,
    },
    headerRemoveAllLink: linkGetActionLinkProps(TrashFill),
    headerCompareLink: mergeProps<ProductCompareFlyOutStyles["headerCompareLink"]>(
        linkGetActionLinkProps(CompareFill),
        {
            css: css`
                ${inlineSeparatorStyles({ spacing: pxToRem(23) })}
            `,
        },
    ),
    carouselDrawerContainer: {
        css: css`
            position: relative;
            width: 100%;
        `,
    },
    carouselContainer: {
        css: css`
            overflow: hidden;
        `,
    },
    carouselSlidesContainer: {
        css: css`
            display: flex;
            overflow-x: auto;
            gap: ${slideGap};
        `,
    },
    carouselSlide: mergeProps<ProductCompareFlyOutStyles["carouselSlide"]>(productCardProps.card, {
        css: css`
            position: relative;
            flex-shrink: 0;
            ${breakpointValues(
                slideInView.map(x => (x ? `calc((100% - (${slideGap} * ${x - 1})) / ${x})` : null)),
                "flex-basis",
            )}
            height: auto;
            padding: ${pxToRem(10)};
            background: ${getColor("invert.main")};
        `,
    }),
    carouselSlideInner: {},
    emptySlideInner: {
        css: css`
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: inherit;
            background-color: rgba(0, 0, 0, 0.05);
            text-align: center;
        `,
    },
    accordionSection: {
        headerProps: {
            as: "div",
            css: css`
                ${x => x.theme.accordion.sectionDefaultProps?.headerProps?.css}
                background: transparent;

                button {
                    ${focusUpdateStyles(true)}
                    ${({ theme }) => css`
                        ${breakpointValues(theme.design.accordion.padding.horizontal, "padding-top")}
                    `}
                    padding-bottom: 0;

                    &[aria-expanded="true"] {
                        ${accordionSectionStyles()}
                    }

                    &:focus,
                    &:focus-visible {
                        ${focusUpdateStyles(true)}
                        ${({ theme }) => css`
                            ${breakpointValues(theme.design.accordion.padding.horizontal, "padding-top")}
                        `}
                        padding-bottom: 0;

                        &[aria-expanded="true"] {
                            ${({ theme }) => css`
                                ${breakpointValues(theme.design.accordion.padding.horizontal, "padding-top")}
                            `}
                            ${accordionSectionStyles()}
                        }
                    }
                }
            `,
        },
        panelProps: {
            as: "div",
            css: css`
                ${x => x.theme.accordion.sectionDefaultProps?.panelProps?.css}
                border: none;
                background: none;

                & {
                    padding: 0;
                }
            `,
        },
    },
    condensedActions: {
        css: css`
            flex-basis: 5%;
        `,
    },
};

const mapProductsToSlides = (
    products: ProductModel[],
    styles: ProductCompareFlyOutStyles,
    removeProductIdToCompare: (productId: string) => void,
) =>
    products.map(product => ({
        id: product.id,
        renderComponent: function ProductCarouselProductCondensedRenderer() {
            return (
                <StyledWrapper key={product.id} {...styles.carouselSlide} /* Starter Custom Code */>
                    <StyledWrapper {...styles.carouselSlideInner} /* Starter Custom Code */>
                        <ProductCarouselProductCondensed
                            carouselId={PRODUCT_COMPARE_CAROUSEL_ID}
                            product={product}
                            labelsVisible={false}
                            showImage={true}
                            showBrand={false}
                            showTitle={true}
                            showPartNumbers={true}
                            showPrice={true}
                            showAddToCart={false}
                            showAddToList={false}
                            condensedActionsTemplate={(product: ProductModel) => {
                                return (
                                    <StyledWrapper {...styles.condensedActions} /* Starter Custom Code */>
                                        <Button
                                            {...styles.removeProductFromCompareButton}
                                            onClick={() => removeProductIdToCompare(product.id)}
                                            data-test-selector="productCompareRemoveProductButton"
                                            data-test-key={product.id}
                                        >
                                            <VisuallyHidden>
                                                {translate(
                                                    "Remove Item {0} from Compare" /* Starter Custom Code */,
                                                    product.productTitle,
                                                )}
                                            </VisuallyHidden>
                                            <ButtonIcon
                                                {...styles.removeProductFromCompareButtonIcon}
                                                /* Starter Removed - src */
                                            />
                                        </Button>
                                    </StyledWrapper>
                                );
                            }}
                        />
                    </StyledWrapper>
                </StyledWrapper>
            );
        },
    }));

const ProductCompareFlyOut = ({
    extendedStyles,
    history,
    productIds,
    products,
    productComparePageLink,
    currentLocation,
    loadProductIdsToCompare,
    loadProductsToCompare,
    removeProductIdToCompare,
    removeAllProductsFromCompare,
    setProductCompareReturnUrl,
}: Props) => {
    const [styles] = useState(() => mergeToNew(productCompareFlyOutStyles, extendedStyles));

    const [slides, setSlides] = useState<CarouselSlide[]>([]);

    const [isExpanded, setIsExpanded] = useState<boolean>(false); // Starter Custom Code

    /* Starter Custom Code - Start */
    const onClickAccordionSection = () => () => {
        setIsExpanded(!isExpanded);
    };
    /* Starter Custom Code - End */

    useEffect(() => {
        // We load in the ProductIds to Compare from storage
        loadProductIdsToCompare();

        /* Starter Custom Code - Start */
        return () => {
            setBottomSpacing(0);
        };
        /* Starter Custom Code - End */
    }, []);

    useEffect(() => {
        // Load in products from the ProductCompareService Compare Storage
        if (productIds.length === 0) {
            return;
        }

        loadProductsToCompare({ id: PRODUCT_COMPARE_CAROUSEL_ID, productIds, includeAttributeTypes: true });
    }, [productIds]);

    useEffect(() => {
        if (products.length === 0) {
            return;
        }
        setSlides(mapProductsToSlides(products, styles, productId => removeProductIdToCompare({ productId })));
        setIsExpanded(true); // Starter Custom Code
    }, [products, styles]);

    /* Starter Custom Code - Start */
    const { clientWidth } = useWindowContext();
    const { setBottomSpacing } = useSiteContext();
    let drawerRef: any;
    const setScrimRef = (ref: Ref<HTMLDivElement>) => {
        drawerRef = ref;
    };

    useEffect(() => {
        setBottomSpacing(drawerRef?.current?.offsetHeight || 0);
    }, [clientWidth, products, isExpanded]);
    /* Starter Custom Code - End */

    const handleRemoveAll = () => {
        removeAllProductsFromCompare();
    };
    const handleOpenCompare = () => {
        if (productComparePageLink) {
            setProductCompareReturnUrl({ returnUrl: currentLocation.pathname + currentLocation.search });
            history.push(productComparePageLink.url);
        }
    };

    if (products.length === 0) {
        return null;
    }

    const emptySlidesArray = productCompareEmptySlides(slides.length); // Starter Custom Code

    return (
        <Drawer
            isOpen={true}
            // Starter Removed - headline
            {...styles.carouselDrawer}
            data-test-selector="productCompareDrawer"
            setOverlayScrimRef={setScrimRef} // Starter Custom Code
        >
            {/* Starter Custom Code - Start */}
            <Accordion headingLevel={2} {...styles.accordion}>
                <AccordionSection
                    {...styles.accordionSection}
                    expanded={isExpanded}
                    onTogglePanel={onClickAccordionSection()}
                    title={
                        <ProductCompareHeader
                            styles={styles}
                            productCount={products.length}
                            onOpenCompare={handleOpenCompare}
                            onRemoveAll={handleRemoveAll}
                        />
                    }
                >
                    <StyledWrapper {...styles.actionsWrapper}>
                        <Link
                            {...styles.headerCompareLink}
                            onClick={handleOpenCompare}
                            disabled={products.length === 1}
                            data-test-selector="productCompareOpenComparePageButton"
                        >
                            {translate("Compare")}
                            <VisuallyHidden>{translate("{0} Items", products.length.toString())}</VisuallyHidden>
                        </Link>
                        <Link
                            {...styles.headerRemoveAllLink}
                            onClick={handleRemoveAll}
                            data-test-selector="productCompareRemoveAllButton"
                        >
                            {translate("Remove All")}
                            <VisuallyHidden>
                                {translate("{0} Items from Compare", products.length.toString())}
                            </VisuallyHidden>
                        </Link>
                    </StyledWrapper>
                    <StyledWrapper {...styles.carouselDrawerContainer}>
                        <StyledWrapper {...styles.carouselContainer} /* Starter Custom Code */>
                            <StyledWrapper {...styles.carouselSlidesContainer} /* Starter Custom Code */>
                                {/* Starter Removed - Carousel */}
                                {slides.map(slide => slide.renderComponent({}))}
                                {emptySlidesArray.map(slide => (
                                    <StyledWrapper key={slide} {...styles.carouselSlide}>
                                        <StyledWrapper {...styles.emptySlideInner}>
                                            <Typography>
                                                {translate(
                                                    "{0} of {1}",
                                                    `${
                                                        constants.productCompare.maxNumberOfColumns -
                                                        (emptySlidesArray.length - slide)
                                                    }`,
                                                    constants.productCompare.maxNumberOfColumns.toString(),
                                                )}
                                            </Typography>
                                        </StyledWrapper>
                                    </StyledWrapper>
                                ))}
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                </AccordionSection>
            </Accordion>
            {/* Starter Custom Code - End */}
        </Drawer>
    );
};

interface ProductCompareHeaderProps {
    styles: ProductCompareFlyOutStyles;
    productCount: number;
    onOpenCompare: () => void;
    onRemoveAll: () => void;
}

const ProductCompareHeader = ({ styles, productCount, onOpenCompare, onRemoveAll }: ProductCompareHeaderProps) => {
    return (
        /* Starter Custom Code - Start */
        <Typography {...styles.headerTitleText}>
            {translate(
                "Compare {0} Items of {1}",
                productCount.toString(),
                constants.productCompare.maxNumberOfColumns.toString(),
            )}
        </Typography>
        /* Starter Custom Code - End */
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withHistory(ProductCompareFlyOut));
